import Joi from 'joi';
import schemas from 'components/forms/fields/definedSchemas';

const fields = {
    ssl_type: {
        ...schemas.textRequired,
        section: 'Date of Transcript',
        initialValue: 'uscgtoss',
        hidden: true,
    },
    date_document_signed: {
        ...schemas.dateRequiredMaxToday,
        section: 'Date of Transcript',
        label: 'What is the date on the TOSS?',
    },
    vessel_id: {
        label: 'Vessel',
    },
    uscg_vessel_class: {
        ...schemas.selectOptional,
        section: 'Vessel',
        label: 'Vessel Class',
        options: {
            'Icebreakers, 420-foot Healy class (WAGB)':
                'Icebreakers, 420-foot Healy class (WAGB)',
            'Icebreakers, 399-foot Polar class (WAGB)':
                'Icebreakers, 399-foot Polar class (WAGB)',
            'Icebreakers, 240-foot Great Lakes class (WLBB)':
                'Icebreakers, 240-foot Great Lakes class (WLBB)',
            'National Security Cutter (NSC), 418-foot Legend class':
                'National Security Cutter (NSC), 418-foot Legend class',
            'High Endurance Cutters, 378-foot Secretary class (WHEC)':
                'High Endurance Cutters, 378-foot Secretary class (WHEC)',
            'Offshore Patrol Cutter': 'Offshore Patrol Cutter',
            '295-foot Cutter Eagle (WIX)': '295-foot Cutter Eagle (WIX)',
            'Medium Endurance Cutter 282-foot Alex Haley class (WMEC)':
                'Medium Endurance Cutter 282-foot Alex Haley class (WMEC)',
            'Medium Endurance Cutter 270-foot Famous class (WMEC)':
                'Medium Endurance Cutter 270-foot Famous class (WMEC)',
            'Medium Endurance Cutter, 210-foot Reliance class (WMEC)':
                'Medium Endurance Cutter, 210-foot Reliance class (WMEC)',
            'Coastal Buoy Tender, 175-foot Keeper class (WLM)':
                'Coastal Buoy Tender, 175-foot Keeper class (WLM)',
            'Inland Construction Tenders (WLIC) 160-foot':
                'Inland Construction Tenders (WLIC) 160-foot',
            'Inland Construction Tenders (WLIC) 100-foot':
                'Inland Construction Tenders (WLIC) 100-foot',
            'Inland Construction Tenders (WLIC) 75-foot':
                'Inland Construction Tenders (WLIC) 75-foot',
            'Ice Breaking Tug, 140-foot Bay class (WTGB)':
                'Ice Breaking Tug, 140-foot Bay class (WTGB)',
            'River Buoy Tenders (WLR)': 'River Buoy Tenders (WLR)',
            '75-foot Kankakee-Class River Buoy Tenders:':
                '75-foot Kankakee-Class River Buoy Tenders',
            '75-foot Gasconade-Class River Buoy Tenders':
                '75-foot Gasconade-Class River Buoy Tenders',
            '65-foot Class River Buoy Tenders:': '65-foot Class River Buoy Tenders',
            '100-foot Inland Buoy Tenders': '100-foot Inland Buoy Tenders',
            '65-foot Inland Buoy Tenders': '65-foot Inland Buoy Tenders',
            'Fast Response Cutter (WPC), 154-foot Sentinel class':
                'Fast Response Cutter (WPC), 154-foot Sentinel class',
            'Patrol Boat, 110-foot Island class (WPB)':
                'Patrol Boat, 110-foot Island class (WPB)',
            'Coastal Patrol Boat (WPB), 87-foot Marine Protector class':
                'Coastal Patrol Boat (WPB), 87-foot Marine Protector class',
            '65-foot Small Harbor Tug (WYTL)': '65-foot Small Harbor Tug (WYTL)',
        },
    },
    date_reported: {
        ...schemas.dateRequiredMaxToday,
        section: 'ShipmentAndDischarge',
        label: 'Date Reported',
    },
    date_detached: {
        ...schemas.dateRequiredMaxToday,
        section: 'ShipmentAndDischarge',
        label: 'Date Detached',
        validation: schemas.dateRequiredMaxToday.validation
            .min(Joi.ref('date_reported'))
            .messages({
                'date.min': "End date can't be before start date.",
                'date.max': 'Dates in the future not allowed.',
            }),
    },
    rank_type: {
        ...schemas.selectRequired,
        section: 'RankRating',
        label: 'Rank Type',
        options: {
            Enlisted: 'Enlisted',
            CWO: 'CWO',
            'Commissioned Officer': 'Commissioned Officer',
        },
    },
    rank_E: {
        ...schemas.selectRequired,
        section: 'RankRating',
        label: 'Rank',
        options: {
            'E-1': 'E-1',
            'E-2': 'E-2',
            'E-3': 'E-3',
            'E-4': 'E-4',
            'E-5': 'E-5',
            'E-6': 'E-6',
            'E-7': 'E-7',
            'E-8': 'E-8',
            'E-9': 'E-9',
        },
        validation: Joi.string().when(Joi.ref('rank_type'), {
            is: 'Enlisted',
            then: Joi.string().required(),
            otherwise: Joi.string().allow(''),
        }),
    },
    rank_CWO: {
        ...schemas.selectRequired,
        section: 'RankRating',
        label: 'Rank',
        options: {
            CWO2: 'CWO2',
            CWO3: 'CWO3',
            CWO4: 'CWO4',
        },
        validation: Joi.string().when(Joi.ref('rank_type'), {
            is: 'CWO',
            then: Joi.string().required(),
            otherwise: Joi.string().allow(''),
        }),
    },
    rank_O: {
        ...schemas.selectRequired,
        section: 'RankRating',
        label: 'Rank',
        options: {
            'O-1': 'O-1',
            'O-2': 'O-2',
            'O-3': 'O-3',
            'O-4': 'O-4',
            'O-5': 'O-5',
            'O-6': 'O-6',
            'O-7': 'O-7',
            'O-8': 'O-8',
            'O-9': 'O-9',
            'O-10': 'O-10',
        },
        validation: Joi.string().when(Joi.ref('rank_type'), {
            is: 'Commissioned Officer',
            then: Joi.string().required(),
            otherwise: Joi.string().allow(''),
        }),
    },
    rating: {
        ...schemas.selectRequired,
        section: 'RankRating',
        label: 'Rating',
        options: {
            BM: 'BM',
            BT: 'BT',
            DC: 'DC',
            EM: 'EM',
            EN: 'EN',
            FA: 'FA',
            FN: 'FN',
            GM: 'GM',
            GS: 'GS',
            GSE: 'GSE',
            GSM: 'GSM',
            HT: 'HT',
            IC: 'IC',
            MK: 'MK',
            MR: 'MR',
            OS: 'OS',
            QM: 'QM',
            RD: 'RD',
            SA: 'SA',
            SM: 'SM',
            SN: 'SN',
            TT: 'TT',
        },
        validation: Joi.string().when(Joi.ref('rank_type'), {
            switch: [
                {
                    is: 'Enlisted',
                    then: Joi.required(),
                },
                {
                    is: 'CWO',
                    then: Joi.required(),
                },
            ],
            otherwise: Joi.allow(''),
        }),
    },
    department: {
        ...schemas.radioRequired,
        section: 'ShipmentAndDischarge',
        label: 'Did you serve in the Deck Department or the Engine Department?',
        options: {Deck: 'Deck', Engine: 'Engine'},
    },

    deck_position_served: {
        ...schemas.selectRequired,
        section: 'ShipmentAndDischarge',
        label: 'Deck Position Served',
        validation: Joi.string()
            .max(100)
            .when(Joi.ref('department'), {
                is: 'Deck',
                then: Joi.string().required(),
                otherwise: Joi.string().allow(''),
            }),
        options: {
            'Deck Dept': 'Deck Dept',
            CO: 'Commanding Officer (CO)',
            OIC: 'Officer in Charge (OIC)',
            XO: 'Executive Officer (XO)',
            XPO: 'Executive Petty Officer (XPO)',
            OPS: 'Operations Officer (OPS)',
            DWO: 'Deck Watch Officer (DWO)',
            OOD: 'Officer of the Deck (OOD)',
            JOOD: 'Junior Officer of the Deck (JOOD)',
            NAV: 'Navigation Officer (NAV-O)',
            ANAV: 'Assistant Navigator (A-NAV)',
            AOPS: 'Assistant Operations Officer (A-OPS)',
            SUPPO: 'Supply Officer',
            CICO: 'CIC Officer',
            JO: 'Junior Officer',
        },
    },
    engine_position_served: {
        ...schemas.selectRequired,
        section: 'ShipmentAndDischarge',
        label: 'Engine Position Served',
        validation: Joi.string()
            .max(100)
            .when(Joi.ref('department'), {
                is: 'Engine',
                then: Joi.string().required(),
                otherwise: Joi.string().allow(''),
            }),
        options: {
            'Engineering Dept': 'Engineering Dept',
            EO: 'Engineering Officer (EO)',
            EPO: 'Engineering Petty Officer (EPO)',
            EOIT: 'Engineering Officer in Training (EOIT)',
            FN: 'Fireman apprentice (FA) or Fireman (FN)',
        },
    },

    // deck_supervised: {
    //     ...schemas.boolOptional,
    //     section: 'ShipmentAndDischarge',
    //     label:
    //         'Did you perform Bridge Watchkeeping duties under supervision during any portion of this time?',
    //     initialValue: null,
    // },
    // deck_performed_under_supervision_days: {
    //     ...schemas.integerOptional,
    //     section: 'ShipmentAndDischarge',
    //     label: 'Number of days of Supervised Bridge Watchkeeping',
    //     validation: Joi.number()
    //         .integer()
    //         .min(0)
    //         .when(Joi.ref('deck_supervised'), {
    //             is: true,
    //             then: Joi.number().required().messages({
    //                 'any.required': 'Please enter the number of days.',
    //             }),
    //             otherwise: Joi.number().allow(null),
    //         }),
    //     initialValue: null,
    // },
    // engine_supervised: {
    //     ...schemas.boolOptional,
    //     section: 'ShipmentAndDischarge',
    //     label:
    //         'Did you perform Engine Watchkeeping duties under supervision during any portion of this time?',
    //     initialValue: null,
    // },
    // engine_performed_under_supervision_days: {
    //     ...schemas.integerOptional,
    //     section: 'ShipmentAndDischarge',
    //     label: 'Number of Days of Supervised Engine Watchkeeping',
    //     validation: Joi.number()
    //         .integer()
    //         .min(0)
    //         .when(Joi.ref('engine_supervised'), {
    //             is: true,
    //             then: Joi.number().required().messages({
    //                 'any.required': 'Please enter the number of days.',
    //             }),
    //             otherwise: Joi.number().allow(null),
    //         }),
    //     initialValue: null,
    // },
    watertype: {
        ...schemas.selectRequired,
        section: 'ShipmentAndDischarge',
        label: 'Water Type',
        validation: Joi.string().max(100).required(),
        options: {
            Oceans: 'Oceans',
            'Near Coastal': 'Near Coastal',
            Inland: 'Inland',
            'Great Lakes': 'Great Lakes',
            'Western Rivers': 'Western Rivers',
        },
    },
    also_polar: {
        ...schemas.boolOptional,
        section: 'ShipmentAndDischarge',
        label: 'Does this sea service entry documented on your letter indicate Polar, Arctic, or Antarctic service?',
    },
};

export default fields;
